module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('nav', [_c('a', {
    class: _vm.navClass('lesson1'),
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.currentLesson = 'lesson1'
      }
    }
  }, [_vm._v("Lesson 1")]), _vm._v(" "), _c('a', {
    class: _vm.navClass('lesson2'),
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.currentLesson = 'lesson2'
      }
    }
  }, [_vm._v("Lesson 2")]), _vm._v(" "), _c('a', {
    class: _vm.navClass('lesson3'),
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.currentLesson = 'lesson3'
      }
    }
  }, [_vm._v("Lesson 3")])]), _vm._v(" "), _c(_vm.currentLesson, {
    tag: "component"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61a7b2ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 31
// module chunks = 0